export default __webpack_public_path__ + "static/media/garmin-connect.a4443af8.svg";